import Vue from 'vue';
import TruffleContract from 'truffle-contract';
import CardOwnership from '../../build/contracts/CardOwnership.json';
import normalizeData from '../util/normalizeData';
import { transformDna } from '../util/transformDna';
import { battleLogic } from "../util/battleLogic";

export default {

    // NEW

    setToken (state, payload) {
        state.token = payload.token;
    },

    addToken (state, payload) {
        state.tokens.push(payload.token);
    },

    addContractToken (state, payload) {
        state.contractTokens.push(payload.token);
    },

    setTokens (state, payload) {
        state.tokens = payload.tokens;
    },

    setContractTokens (state, payload) {
        state.contractTokens = payload.contractTokens;
    },

    setRegisteredTokens (state, payload) {
        state.registeredTokens = payload.registeredTokens;
    },

    incrementRegisteredTokens (state, payload) {
        state.registeredTokens+=1;
    },

    setContract (state, payload) {
        state.contract = payload.contract;
    },

    setContractDetails (state, payload) {
        state.contractDetails = payload.contractDetails;
    },
 



    // ***** \\
    // CARDS \\
    // ***** \\

    setCard (state, payload) {
        state.card = payload;
    },
 
    setCards (state, payload) {
        state.cards = payload.cards;
    },
 
    setAllCards (state, payload) {
        state.allCards = payload.cards;
    },
 
    resetUserCards (state, payload) {
        state.cards = [];
    },
 
    updateUserCards (state, payload) {
        const userCards = [];
        for (let i = 0; i < state.allCards.length; i++) {
            if (payload.address == state.allCards[i].owner) {
                userCards.push(state.allCards[i]);
            }
        }
        state.cards = userCards;
    },
 
    addToCards (state, payload) {
        payload.new = true;
        state.cards.unshift(payload);
    },
 
    addToCardsById (state, payload) {
        for (let i = 0; i < state.allCards.length; i++ ) {
            if (state.allCards[i].id == payload.id) {
                state.allCards[i].new = true;
                state.cards.unshift(state.allCards[i]);
                break;
            }
        }
    },
 
    addToAllCards (state, payload) {
        payload.card.new = true;
        state.allCards.unshift(payload.card);
    },
 
    removeFromCardsById (state, payload) {
        for (let i = 0; i < state.cards.length; i++ ) {
            if (state.cards[i].id == payload.id) {
                state.cards.splice(i, 1);
                break;
            }
        }
    },

    addToSelectedCards (state, payload) {
        state.selectedCards.push(payload);
    },

    removeFromSelectedCardsWithIndex (state, payload) {
        state.selectedCards[payload.index].selected = false;
        state.selectedCards.splice(payload.index, 1);
    },

    resetSelectedCards (state, payload) {
        state.selectedCards = payload;
    },

    removeSelectedCardsStatus (state, payload) {
        for (let i = 0; i < state.cards.length; i++) {
            Vue.set(state.cards[i], 'selected', false);
        }
    },

    updateCardLockStatus (state, payload) {
        for (let i = 0; i < state.cards.length; i++ ) {
            if (state.cards[i].id == payload.id) {
                state.cards[i].isLocked = payload.isLocked;
                state.cards[i].lockType = payload.lockType;
                break;
            }
        }
    },

    updateCardLevel (state, payload) {
        const cards = payload.cards;
        for (let i = 0; i < cards.length; i++) {
            for (let j = 0; j < state.cards.length; j++) {
                if (cards[i] == state.cards[j].id) {
                    state.cards[j].levelUp = true;
                    Vue.set(state.cards[j], 'level', state.cards[j].level+1);
                    break;
                }
            }
        }
    },

    levelupCardByLevels (state, payload) {

        const id = payload.id;
        const levels = parseInt(payload.levels);

        for (let i = 0; i < state.cards.length; i++) {
            
            if (state.cards[i].id == id) {
                state.cards[i].levelUp = true;
                Vue.set(state.cards[i], 'level', parseInt(state.cards[i].level)+levels);
                
                state.card = state.cards[i];
                break;
            }
            
        }

    },  

    setCardsCreated (state, payload) {
        state.cardsCreated = parseInt(payload.cardsCreated);
    },

    incrementCardCounter (state, payload) {
        state.cardsCreated++;
    },

    setCardCounterLoading (state, payload) {
        state.cardCounterLoading = payload.loading;
    },

    setCardLoading (state, payload) {
        state.cardLoading = payload.loading;
    },

    // ******* \\
    // BATTLES \\
    // ******* \\

    setBattle (state, payload) {
        state.battle = payload;
    },

    setBattles (state, payload) {
        state.battles = payload.battles;
    },
    
    addToBattles (state, payload) {
        state.battles.unshift(payload);
    },
    
    setBattleCards (state, payload) {
        Vue.set(state.battle, 'ownerCards', payload.ownerCards);
        Vue.set(state.battle, 'opponentCards', payload.opponentCards);
    },
    
    updateBattleResults (state, payload) {
        state.battleResults = payload.results;
    },
    
    updateBattleCompleteState (state, payload) {
        for (let i = 0; i < state.battles.length; i++) {
            if (state.battles[i].id == payload.id) {
                state.battles[i].isComplete = payload.isComplete;
                state.battles[i].opponent = payload.opponent;
                state.battles[i].winner = payload.winner;
                state.battles[i].opponentCardIds = payload.opponentCardIds;
                break;
            }
        }
    },
    
    setFilteredBattles (state, getters) {
        const currentUser = Vue.localStorage.get('user-address');
        let filters = state.battleFilters;
        let filteredBattles = [];

        // Capture filters
        if (!filters.onlyMe && filters.status == 'all' && filters.score == 'all') {
            state.filteredBattles = state.battles;
            return;
        }

        let status = false;
        let score = false;
        let onlyMe = false;

        filteredBattles = state.battles.filter(battle => {

            if (filters.onlyMe) {

                onlyMe = (currentUser == battle.owner || currentUser == battle.opponent);

            } else {
                onlyMe = true;
            }

            if (filters.score != 'all') {

                let scoreGroup = filters.score.split('-');
                score = battle.teamScore > parseInt(scoreGroup[0]) && battle.teamScore < parseInt(scoreGroup[1]);

            } else {
                score = true;
            }

            if (filters.status != 'all') {

                status = filters.status == 'open' ? !battle.isComplete : battle.isComplete;

            } else {
                status = true;
            }

            return onlyMe && score && status;      
        }); 

        state.filteredBattles = filteredBattles;
    },

    setBattleLoading (state, payload) {
        state.battleLoading = payload.loading;
    },

    setOpenBattleIds (state, payload) {
        const openBattleIds = payload.openBattleIds;

        Vue.localStorage.set('openBattleIds', openBattleIds);
        state.openBattleIds = openBattleIds
    },

    restoreOpenBattleIds (state) {
        const openBattleIds = Vue.localStorage.get('openBattleIds');

        if (openBattleIds) {
            state.openBattleIds = openBattleIds;
        }
    },

    // ******** \\
    // AUCTIONS \\
    // ******** \\

    setAuctions (state, payload) {
        state.auctions = payload.auctions;
    },

    addToAuctions (state, payload) {
        state.auctions.unshift(payload);
    },
    
    updateAuctionCompleteStatus (state, payload) {
        for (let i = 0; i < state.auctions.length; i++) {
            if (state.auctions[i].id == payload.auction.id) {
                Vue.set(state.auctions[i], 'isComplete', payload.auction.isComplete);
                break;
            }
        }    
    },

    setAuctionLoading (state, payload) {
        state.auctionLoading = payload.loading;
    },

    // ***** \\
    // USERS \\ 
    // ***** \\

    setUser (state, payload) {
        const address = payload.address;
        Vue.localStorage.set('user-address', address);

        for (let i = 0; i < state.users.length; i++) {
            if (state.users[i].address == address) {
                state.user = state.users[i];
                return;
            }     
        }

        Vue.set(state.user, 'address', address);
    },

    restoreUser (state) {
        const address = Vue.localStorage.get('user-address');

        if (!address) return;

        for (let i = 0; i < state.users.length; i++) {
            if (state.users[i].address == address) {
                state.user = state.users[i];
                return;
            }       
        }

        Vue.set(state.user, 'address', address);
    },

    resetUser (state, payload) {
        Vue.localStorage.remove('user-address');

        state.user = {
            address: null,
            winCount: 0,
            lossCount: 0,
            tokens: 0
        }
    },

    setUsers (state, payload) {
        state.users = payload.users;
    },

    addNewUser (state, payload) {
        if (state.users[payload.account]) return;
        Vue.set(state.users, payload.account, { winCount: 0, lossCount: 0 });
    },

    incrementUserBattleStat (state, payload) {
        state.users[payload.account][payload.stat]++;
    },

    updateUserBattleStats (state, payload) {
        const status = payload.status;

        if (status == 'win') {
            state.user.winCount+=1;
            state.user.tokens+=5;
        } else {
            state.user.lossCount+=1;
        }

        for (let i = 0; i < state.users.length; i++) {
            if (state.users[i].address == state.user.address) {
                state.users[i] = state.user;
                break;
            }
        }
    },

    subtractUserTokens (state, payload) {
        const id = state.user.id;
        const levels = payload.levels * 5;

        for (let i = 0; i < state.users.length; i++) {
            if (state.users[i].id == id) {
                let tokens = parseInt(state.user.tokens)-levels;
                Vue.set(state.users[i], 'tokens', tokens);
                Vue.set(state.user, 'tokens', tokens);
                return;
            }
        }
    },

    setUserLoading (state, payload) {
        state.userLoading = payload.loading;
    },

    // ******* \\
    // GENERAL \\
    // ******* \\

    setModalType (state, payload) {
        state.modalType = payload;
    },
    
    updateLoading (state, payload) {
        state.loading = payload.loading;
    },
    
    updatePendingTransaction (state, payload) {
        state.pendingTransaction = payload.status;
    },
    
    updateHasExtension (state, payload) {
        state.hasExtension = payload.hasExtension;
    },

    setHasError (state, payload) {
        state.hasError = payload.error;
    },

    setLocale (state, payload) {
        
        const locale = payload.locale;

        Vue.localStorage.set('locale', locale);
        state.locale = locale;

    },

    restoreLocale (state, payload) {
        const locale = Vue.localStorage.get('locale');

        if (locale) {
            state.locale = locale;
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/store/mutations.js